
	/* Toggle list elements */
	const	listToggle = document.querySelectorAll( '.list-toggle' ),
			openListToggle = document.querySelectorAll( '.list-toggle-open' )

	if ( listToggle && openListToggle ) {

		openListToggle.forEach( function( openListToggle ) {

			openListToggle.addEventListener( 'click', function( e ) {

				const list = e.target.previousElementSibling;
				
				if ( list ) {
					list.querySelectorAll( '.list-toggle' ).forEach( function( listHidden ) {
						listHidden.classList.remove( 'list-toggle' );
					} );
				}

				e.target.remove();
				
			} );

		} );

	}